'use client';

import React from 'react';

import { useConfig } from '../appconfig/ConfigContext';

const AppConfig: React.FC = () => {
  const config = useConfig();

  return (
    <div className="mx-auto px-4 ">
      <div className="p-4 mb-4 text-sm text-gray-500 rounded-radius-400" role="alert">
        <h2 className="font-bold">App Configuration Info</h2>
        <div className="font-medium">
          Resource Code: {config?.user?.resourceCode || 'Resource code not available'}
        </div>
        <div>
          APP Version:{' '}
          {config?.user?.userManagement?.apiVersion || 'API Version not available'}
        </div>
      </div>
    </div>
  );
};

export default AppConfig;
